/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withHandlers } from 'recompose';
import Star from 'components/svg/Star';
import { Button } from 'components/core/Button';

export const enhance = withHandlers({
	onMouseEnter: (props) => () => props.onMouseEnter(props.value),
	onClick: (props) => () => props.onClick(props.value),
});

export function StarButton({ className, onClick, onMouseEnter, onMouseLeave }) {
	return (
		<Button
			primary={false}
			className={classnames('star-button', className)}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			onClick={onClick}
		>
			<Star value={1} />
		</Button>
	);
}

StarButton.propTypes = {
	className: PropTypes.string,
	onClick: PropTypes.func,
	onMouseEnter: PropTypes.func,
	onMouseLeave: PropTypes.func,
};

export default enhance(StarButton);
